/* Copyright (c) 2018-2025, NVIDIA CORPORATION.  All rights reserved.
 *
 * NVIDIA CORPORATION and its licensors retain all intellectual property
 * and proprietary rights in and to this software, related documentation
 * and any modifications thereto.  Any use, reproduction, disclosure or
 * distribution of this software and related documentation without an express
 * license agreement from NVIDIA CORPORATION is strictly prohibited.
 */

import { Injectable } from '@angular/core';
import { RetryConfig } from 'nv-angular-http-endpoint/lib/nv-http-endpoint/nv-http-endpoint';

@Injectable()
export class JsEventsServerConfig {
    server: string;
    version: string;
    schemaVersion: string;
    msBetweenSendRequest: number;
    maxEventsPerRequest: number;
    clientId: string;
    systemInfoEventDelay: number;
    productName?: string;
    retryConfig?: RetryConfig;
}
